import { render } from "./ApplyRecord.vue?vue&type=template&id=a2deb66e"
import script from "./ApplyRecord.vue?vue&type=script&lang=js"
export * from "./ApplyRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__